import {t} from 'i18next';
import {CSSProperties, useEffect, useState} from 'react';
import {WeddingOfficiantDB, DisplayMessage} from '../lib/interfaces';
import {getWeddingOfficiants} from '../services/weddingOfficiantServices';
import {UaDropdown, UaSpinner} from 'uppsala.ui.react';

interface WeddingOfficiantDropdownProps {
  label?: string;
  onSelect: (selectedWeddingOfficiant?: WeddingOfficiantDB) => void;
  style?: CSSProperties;
  setDisplayMessage: (message: DisplayMessage) => void;
  valid?: boolean;
}

export const WeddingOfficiantDropdown = (props: WeddingOfficiantDropdownProps) => {
  const [loading, setLoading] = useState(true);
  const [weddingOfficiants, setWeddingOfficiants] = useState<WeddingOfficiantDB[]>([]);

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      const resp = await getWeddingOfficiants();
      setWeddingOfficiants(resp.data ?? []);
      resp.info && props.setDisplayMessage(resp.info);
      setLoading(false);
    };
    fetchData();
  }, []);

  return (
    <div style={props.style}>
      {loading ? (
        <div style={{marginTop: '15px'}}>
          <UaSpinner title={t('status.loadingWeddingOfficiants') ?? 'Hämtar data...'} />
        </div>
      ) : (
        <UaDropdown
          labelName={props.label}
          unselectedOption={t('booking.chooseOfficiant') ?? 'Välj vigselförrättare'}
          options={weddingOfficiants.map((wo) => wo.name)}
          onChange={(selected) => {
            const selectedOfficiant = weddingOfficiants.find((officiant) => officiant.name === selected);
            props.onSelect(selectedOfficiant);
          }}
          valid={props.valid}
        />
      )}
    </div>
  );
};
